import request from '@/utils/request'

export default {
  info: function (form) {
    if (!form) form = {}
    return request({
      url: 'home/info',
      method: 'post',
      data: form
    })
  }
}
